export let data_select = {
    'coleccion': [],
    'categori': [],
    'vis': [],
    'section_type': [],
    'section_type_value': [],
    'type': [],
    'price': [],
    'area': [],
    'cities': [],
    'zone': [],
    'sector': [],
    'alcobas': [],
    'banio': [],
    'garage': [],
    'estrato': [],
    'fecha': [],
    'order': [],
    'department_list': [],
    'constructor_highlight': [],
    'feature': [],
    'nid': [],
    'index': [],
    'sort': []
};
export const data_list = {
    tipo_list: [],
    department_list: [],
    constructor_highlight: [],
    city_list: [],
    zone_list: [],
    sector_list: [],
};
export const list_filters = {
    temp: [],
    precio_list: [],
    area_list: [],
    alcoba_list: [],
    banio_list: [],
    garage_list: [],
    estrato_list: [],
};
export const name_list_filters = {
    alcobas: 'alcoba_list',
    banio: 'banio_list',
    garage: 'garage_list',
    estrato: 'estrato_list',
};
export const data_index = {
    alcobas: 0,
    banio: 0,
    garage: 0,
    estrato: 0,
};
export let builder_id = 0;
export let fecha_list = [];
export let feature_list = [];
export let datosMapSet = [];
export function setBuilderId(id) {
    builder_id = id;
}
export function setFechaList(newList) {
    fecha_list = newList;
}
export function setFeatureList(newList) {
    feature_list = newList;
}
export function resetDataSelect() {
    Object.keys(data_select).forEach((key) => {
        data_select[key] = [];
    });
}
export function setDataSelect(newDataSelect) {
    resetDataSelect();
    Object.assign(data_select, newDataSelect);
}
export function setMapData(data) {
    datosMapSet = data;
}
